import './index.css'

const LanguageFiltersItem = props => {
  const {details, onClickTab, isActive} = props
  const {id, language} = details

  const activeClass = isActive ? 'active-tab' : ''

  return (
    <li>
      <button
        type="button"
        className={`tab-btn ${activeClass}`}
        onClick={() => onClickTab(id)}
      >
        {language}
      </button>
    </li>
  )
}

export default LanguageFiltersItem
